import { Button } from '@/shared/components';

/**
 * Ein gescheiterter Schritt, dessen Aufgabe nach dem Neuladen nicht mehr in der Zeitleiste steht
 * (läuft jetzt, bei anderen, erledigt): der Satz bleibt über dem Plan, bis man ihn schließt.
 */
export function PlanFailureBanner({
  name,
  message,
  onDismiss,
}: {
  name: string;
  message: string;
  onDismiss: () => void;
}) {
  return (
    <div
      role="alert"
      className="border-sealwax/40 bg-sealwax-tint rounded-tile flex items-start gap-3 border p-3"
    >
      <p className="text-sealwax min-w-0 flex-1 text-sm font-semibold">
        {name}: {message}
      </p>
      <Button variant="ghost" className="min-h-11" onClick={onDismiss}>
        Schließen
      </Button>
    </div>
  );
}
